import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=0468fc49&"
import script from "./NotAllowed.vue?vue&type=script&lang=js&"
export * from "./NotAllowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports